const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const request = async (method, path, body) => {
  const headers = { 'Content-Type': 'application/json' };
  const token = localStorage.getItem('token');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_URL}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  const data = await response.json();

  if (!response.ok) {
    const err = new Error(data?.message || response.statusText);
    err.response = { status: response.status, data };
    throw err;
  }

  return data;
};

// Auth API
export const authAPI = {
  authenticate: async (email) => {
    return request('POST', '/auth', { email });
  },

  authenticateTotvs: async (email, username, password) => {
    const data = await request('POST', '/auth', { email, username, password });
    if (data.token) {
      localStorage.setItem('token', data.token);
    }
    return data;
  },

  validateCode: async (email, code) => {
    const data = await request('POST', '/auth/validate', { email, code });
    if (data.token) {
      localStorage.setItem('token', data.token);
    }
    return data;
  },
};

// Campaign API
export const campaignAPI = {
  getCurrentCampaign: async () => {
    return request('GET', '/campaign/current');
  },

  getCurrentResults: async () => {
    return request('GET', '/campaign/current/results');
  },
};

// User API
export const userAPI = {
  getCurrentUser: async () => {
    return request('GET', '/users/current');
  },

  checkIfVoted: async () => {
    return request('GET', '/users/current/vote');
  },
};

// Vote API
export const voteAPI = {
  submitVote: async (vote) => {
    return request('POST', '/vote', { vote });
  },
};
